var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coverImg",class:_vm.imgClass,style:('background-image: url('+(_vm.imgUrl ? (_vm.imgUrl+'?x-oss-process=image/resize,m_lfit,w_270') : _vm.returnImg())+');')})
}
var staticRenderFns = []

export { render, staticRenderFns }